<template>
  <div class="mt-15 container card_container" v-if="jsonData.stepAlpi === 0">
    <b-container class="bv-example-row">
      <div class="mb-5">
        <h3 class="mt-5 mb-5 titolo"><i class="fas fa-laptop-medical"></i> Prenotazione libero professionale</h3>
      </div>
      <!-- <b-row>
        <b-col sm class="mb-7 mt-5 text-center">
          <div class="h-35px">
            <strong class="text-primary">Distretto</strong>
          </div>

          <b-form-radio-group
            :options="provinciaOptions"
            name="radios-btn-default"
            v-model="distrettoResidenza"
            @change="onSelectedZona"
            button-variant="outline-secondary"
            buttons
          >
          </b-form-radio-group>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col sm class="mb-2 mt-5">
          <div class="mb-1">
            <strong class="text-primary">Prestazione</strong>
          </div>
          <b-form-input
            type="text"
            class="form-control form-control-solid"
            name="input1"
            placeholder="Inserisci prestazione"
            value=""
            style="text-transform: uppercase"
            v-model="jsonData.visita"
            v-on:keyup.enter="onCerca"
          />
        </b-col>
      </b-row>

      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
        <a>
          <b-button variant="my-5 btn-outline" class="mb-8" @click="onCerca"><i class="fas fa-search"></i> Cerca </b-button>
        </a>
      </div>
      <div v-if="listaPrestazioni">
        <datatable-lista-prestazioni-alpi :listaPrestazioni="listaPrestazioni" @getPrestazioneSelezionata="getPrestazioneSelezionata"></datatable-lista-prestazioni-alpi>
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <b-button variant="my-5 btn-outline" :disabled="disabilitaAvanti" class="my-5" @click="onAvanti"><i class="fas fa-chevron-right"></i> Avanti </b-button>
        </div>
      </div>
    </b-container>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots" :height="120" :width="120"></loading>
  </div>
  <lista-sedi-alpi
    v-else-if="jsonData.stepAlpi === 1"
    :assistito="assistito"
    @setStep="setStep"
    :prestazioneSelezionata="prestazioneSelezionata"
    @getStrutturaSelezionata="getStrutturaSelezionata"
    :listaStrutture="listaStrutture"
  ></lista-sedi-alpi>
  <disponibilita-alpi
    v-else-if="jsonData.stepAlpi === 2"
    :assistito="assistito"
    @setStep="setStep"
    :prestazioneSelezionata="prestazioneSelezionata"
    :strutturaSelezionata="strutturaSelezionata"
  ></disponibilita-alpi>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import listaSediAlpi from "./listaSediAlpi.vue";
import datatableListaPrestazioniAlpi from "../datatable/datatableListaPrestazioniAlpi.vue";
import DisponibilitaAlpi from "./disponibilitaAlpi.vue";
import EngiService from "@/services/engiService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";

export default {
  components: { Loading, datatableListaPrestazioniAlpi, listaSediAlpi, DisponibilitaAlpi },
  props: { assistito: Object, DisponibilitaAlpi },
  data() {
    return {
      pathResourceListaPrestazioni: "/api/v2.0/appecupt/aslengi/alpi/prestazionierogabili",
      pathResourceSediAlpi: "/api/v2.0/appecupt/aslengi/alpi/unitaOperative",
      jsonData: {
        visita: "",
        provincia: null,
        stepAlpi: 0,
        assistito: this.assistito,
      },
      isLoading: false,
      listaPrestazioni: null,
      zona: "",
      prestazioneSelezionata: null,
      strutturaSelezionata: null,
      listaStrutture: null,
      tokenLogin: null,
      disabilitaAvanti: true,
    };
  },
  mounted: function () {
    let me = this;
    me.tokenLogin = sessionStorage.getItem("loginData");
    //me.setZona();
  },
  methods: {
    async onCerca() {
      let me = this;

      if (me.jsonData.visita != "") {
        try {
          me.isLoading = true;
          const responseRicercaPrestazioniAlpi = await EngiService.prestazioniErogabiliAlpi(me.jsonData.visita);
          if (responseRicercaPrestazioniAlpi.data.stato === 200) {
            if (responseRicercaPrestazioniAlpi.data.data.length !== 0) {
              me.isLoading = false;
              me.listaPrestazioni = responseRicercaPrestazioniAlpi.data.data;
            } else {
              me.isLoading = false;

                let msg = getVocabolario("messaggioNessunaPrestazione")
                if(!msg)
                    msg = "Nessuna Prestazione Trovata"
              me.$bvModal
                .msgBoxOk(msg, {
                  title: "Attenzione",
                  size: "md",
                  okVariant: "outline-danger",
                  headerClass: "vv-msg-header-danger",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then(() => {
                  me.isLoading = false;
                })
                .catch(() => {
                  me.isLoading = false;
                });
              me.isLoading = false;
            }
          } else {
            me.isLoading = false;
            me.$bvModal
              .msgBoxOk(responseRicercaPrestazioniAlpi.data.errore, {
                title: "Errore",
                size: "md",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {
                me.isLoading = false;
              })
              .catch(() => {
                me.isLoading = false;
              });
          }
        } catch (e) {
          me.$bvModal.msgBoxOk(e, {
            title: "Errore",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          me.isLoading = false;
        }
      } else {
        me.isLoading = false;
        return;
      }
    },
    setStep(step) {
      let me = this;
      me.jsonData.stepAlpi = step;
      if (me.jsonData.stepAlpi === 0) {
        me.jsonData.visita = "";
        me.listaPrestazioni = null;
        me.prestazioneSelezionata = null;
      } else if (me.jsonData.stepAlpi === 1) {
        me.strutturaSelezionata = null;
      }
    },
    getPrestazioneSelezionata(item) {
      let me = this;
      me.prestazioneSelezionata = item[0];
    },
    getStrutturaSelezionata(item) {
      let me = this;
      me.strutturaSelezionata = item;
    },
    async onAvanti() {
      let me = this;
      me.isLoading = true;
      try {
        const responseAlpiUnitaOperative = await EngiService.unitaOperativeAlpi(me.prestazioneSelezionata.idPrestazione);
        if (responseAlpiUnitaOperative.data.stato === 200) {
          me.listaStrutture = responseAlpiUnitaOperative.data.data;
          me.isLoading = false;
          me.setStep(1);
        } else {
          me.isLoading = false;
          me.$bvModal
            .msgBoxOk(responseAlpiUnitaOperative.data.errore, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.isLoading = false;
            })
            .catch(() => {
              me.isLoading = false;
            });
        }
      } catch (error) {
        me.$bvModal.msgBoxOk(error, {
          title: "Errore",
          size: "md",
          okVariant: "outline-danger",
          headerClass: "vv-msg-header-danger",
          footerClass: "p-2 border-top-0",
          centered: true,
        });
        me.isLoading = false;
      }
    },
    onSelectedZona(item) {
      let me = this;
      me.zona = item;
      me.onCerca();
    },
    // setZona() {
    //   let me = this;
    //   me.zona =
    //     me.jsonData.assistito.provinciaResidenza.toUpperCase() === "CAMPOBASSO" ? "103" : me.jsonData.assistito.provinciaResidenza.toUpperCase() === "TERMOLI" ? "104" : "105";
    // },
  },
  watch: {
    prestazioneSelezionata: function (data) {
      let me = this;
      if (data !== undefined) {
        me.disabilitaAvanti = false;
      } else {
        me.disabilitaAvanti = true;
      }
    },
  },
};
</script>
